import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

type Props = {
  isEdit: boolean;
  step: number;
  submitting: boolean;
  canProceedFromPartnerStep: boolean;
  onClose: () => void;
  onBack: () => void;
  onNext: () => void;
  onSubmit: () => void;
};

export function SlaPartnerModalFooter({
  isEdit,
  step,
  submitting,
  canProceedFromPartnerStep,
  onClose,
  onBack,
  onNext,
  onSubmit,
}: Props) {
  const { t } = useTranslation('sla');

  return (
    <>
      <Button onClick={onClose}>{t('actions.cancel')}</Button>
      {!isEdit && step > 0 && (
        <Button onClick={onBack}>{t('actions.back')}</Button>
      )}
      {!isEdit && step < 3 && (
        <Button
          type="primary"
          disabled={step === 0 && !canProceedFromPartnerStep}
          onClick={onNext}
        >
          {t('actions.next')}
        </Button>
      )}
      {(isEdit || step === 3) && (
        <Button type="primary" loading={submitting} onClick={onSubmit}>
          {t('actions.confirm')}
        </Button>
      )}
    </>
  );
}
